<template>
  <main class="mt-3">
    <div class="card shadow-none border">
      <div class="card-header font-weight-bold d-flex align-items-center justify-content-between">
        <span><i class="fas fa-exclamation-triangle text-warning mr-2"></i>Factores de Riesgo</span>
      </div>
      <div class="card-body">
        <div class="row align-items-end">
          <div class="col-md-4 col-sm-6 mb-2">
            <label class="font-weight-bolder small">Factor de Riesgo <span class="text-danger">*</span></label>
            <select v-model="selectedCodigo" class="form-control form-control-sm">
              <option value="">-- Seleccione Factor de Riesgo --</option>
              <option v-for="op in opcionesFactores" :key="op.codigo" :value="op.codigo">
                {{ op.codigo }} - {{ op.nombre }}
              </option>
            </select>
          </div>
          <div class="col-md-6 col-sm-6 mb-2">
            <label class="font-weight-bolder small">Descripción / Observaciones</label>
            <input
              type="text"
              v-model="descripcion"
              class="form-control form-control-sm"
              placeholder="Ej. - CONSUMO DE ALCOHOL"
            />
          </div>
          <div class="col-md-2 col-sm-12 mb-2">
            <button
              type="button"
              class="btn btn-primary btn-sm btn-block shadow-sm"
              :disabled="cargando || !selectedCodigo"
              @click="guardarFactorRiesgo"
            >
              <i class="fas fa-save mr-1" v-if="!cargando"></i>
              <i class="fas fa-spinner fa-spin mr-1" v-else></i>
              Guardar
            </button>
          </div>
        </div>

        <!-- Tabla de Factores de Riesgo Registrados -->
        <div class="mt-3" v-if="factores.length > 0">
          <label class="font-weight-bold small text-secondary">Factores de Riesgo Registrados</label>
          <div class="table-responsive">
            <table class="table table-sm table-bordered table-hover mb-0">
              <thead class="bg-light">
                <tr>
                  <th style="width: 90px;">Código</th>
                  <th>Factor de Riesgo</th>
                  <th>Descripción</th>
                  <th style="width: 140px;">Atención</th>
                  <th class="text-center" style="width: 60px;">Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in factores" :key="item.id">
                  <td><span class="badge badge-info">{{ item.codigo }}</span></td>
                  <td class="font-weight-bold">{{ item.nombre }}</td>
                  <td>{{ item.descripcion || 'Sin descripción' }}</td>
                  <td>
                    <span
                      class="badge"
                      :class="item.id_historia == idHistoria ? 'badge-success-soft text-success border border-success' : 'badge-light text-muted border'"
                    >
                      {{ item.id_historia == idHistoria ? 'Atención Actual' : 'Histórico' }}
                    </span>
                  </td>
                  <td class="text-center">
                    <button
                      type="button"
                      class="btn btn-xs btn-outline-danger border-0"
                      title="Eliminar"
                      @click="eliminarFactorRiesgo(item.id)"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import factorRiesgoService from "@/services/factorRiesgoService";
import Toast from "@/components/common/utilities/toast";

export default {
  name: "FactoresRiesgoComponent",
  props: {
    idHistoria: {
      type: [Number, String],
      default: null
    },
    idUsuario: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      selectedCodigo: "",
      descripcion: "",
      cargando: false,
      factores: [],
      opcionesFactores: [
        { codigo: "01", nombre: "Químicos", system: "https://fhir.minsalud.gov.co/rda/CodeSystem/FactorRiesgo" },
        { codigo: "02", nombre: "Físicos", system: "https://fhir.minsalud.gov.co/rda/CodeSystem/FactorRiesgo" },
        { codigo: "03", nombre: "Biomecánicos", system: "https://fhir.minsalud.gov.co/rda/CodeSystem/FactorRiesgo" },
        { codigo: "04", nombre: "Psicosociales", system: "https://fhir.minsalud.gov.co/rda/CodeSystem/FactorRiesgo" },
        { codigo: "05", nombre: "Biológicos", system: "https://fhir.minsalud.gov.co/rda/CodeSystem/FactorRiesgo" },
        { codigo: "06", nombre: "Otro", system: "https://fhir.minsalud.gov.co/rda/CodeSystem/FactorRiesgo" }
      ]
    };
  },
  methods: {
    async cargarFactores() {
      if (!this.idUsuario) return;
      try {
        const res = await factorRiesgoService.getByUsuario(this.idUsuario);
        if (res.data && res.data.status === "ok") {
          this.factores = res.data.data || [];
        }
      } catch (e) {
        console.error("Error al cargar factores de riesgo:", e);
      }
    },
    async guardarFactorRiesgo() {
      if (!this.selectedCodigo) {
        Toast.fire({
          icon: "warning",
          title: "Seleccione un factor de riesgo"
        });
        return;
      }

      const op = this.opcionesFactores.find(o => o.codigo === this.selectedCodigo);
      const nombre = op ? op.nombre : "Otro";

      this.cargando = true;
      try {
        const payload = {
          id_historia: this.idHistoria || null,
          id_usuario: this.idUsuario,
          codigo: this.selectedCodigo,
          nombre: nombre,
          descripcion: this.descripcion
        };

        const res = await factorRiesgoService.store(payload);
        if (res.data && res.data.status === "ok") {
          Toast.fire({
            icon: "success",
            title: "Factor de riesgo guardado"
          });
          this.selectedCodigo = "";
          this.descripcion = "";
          await this.cargarFactores();
        } else {
          Toast.fire({
            icon: "error",
            title: "No se pudo guardar el factor de riesgo"
          });
        }
      } catch (e) {
        console.error("Error al guardar factor de riesgo:", e);
        Toast.fire({
          icon: "error",
          title: "Ocurrió un error al guardar"
        });
      } finally {
        this.cargando = false;
      }
    },
    async eliminarFactorRiesgo(id) {
      try {
        const res = await factorRiesgoService.delete(id);
        if (res.data && res.data.status === "ok") {
          Toast.fire({
            icon: "success",
            title: "Factor de riesgo eliminado"
          });
          await this.cargarFactores();
        }
      } catch (e) {
        console.error("Error al eliminar factor de riesgo:", e);
      }
    }
  },
  watch: {
    idUsuario: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.cargarFactores();
        }
      }
    }
  }
};
</script>
